import React, { useState } from 'react'
import {
     FaEllipsisV, FaFlag, FaInfoCircle,
    FaMarker, FaMinusCircle,
    FaSave, FaShare, FaTimes
} from 'react-icons/fa'
import UserImage from "../../assets/user.png"

import { useNavigate } from 'react-router-dom'


const ShelfAd = ({ ad }) => {

    const navigate = useNavigate()

    // console.log("shelf_ad:", ad)

    const [profileInfo, setProfileInfo] = useState(false)
    const [adInfo, setAdInfo] = useState(false)
 

    const products = ad?.shelf.products || []
    const [focusedProduct, setFocusedProduct] = useState(products[0] || null)

    if (!ad) return null

    const toggleAdInfo = () => {
        setProfileInfo(false)
        setAdInfo(prev => !prev)
    }

    const toggleProfileInfo = () => {
        setAdInfo(false)
        setProfileInfo(prev => !prev)
    }

    const renderProducts = () => {
        if (!focusedProduct?.files?.[0]?.url) return null

        return (
            <>
                <div className="focused-image">
                    <p>{focusedProduct.title}</p>
                    <img
                        src={focusedProduct.files[0].url}
                        alt={focusedProduct.title || "product"}
                    />
                    <p>{focusedProduct.description}</p>
                </div>

                {products.length > 1 && (
                    <div className="image-selector">
                        {products.map((product, i) => (
                            product?.files?.[0]?.url && (
                                <div
                                    key={i}
                                    className="image-selector-wrapper"
                                    onClick={() => setFocusedProduct(product)}
                                >
                                    <img
                                        src={product.files[0].url}
                                        alt={product.title || "product"}
                                    />
                                </div>
                            )
                        ))}
                    </div>
                )}
            </>
        )
    }

    return (
        <div className='ad'>
            <div className="ad-header">
                <div className="profile-details" onClick={() => navigate(`/b/${ad.shelf.storeId.name}`)}>
                    <img
                        src={ad?.shelf.storeId?.logo?.url || UserImage}
                        alt="store profile"
                        className="userad-profile-img"
                    />

                    <div className="ad-data-details">
                        <div className="ad-profile-name" >
                            <p>{ad?.shelf.storeId?.name || "Business"}</p>
                        </div>
                    </div>
                    <p className='promoted-label'>promoted</p>
                </div>

                <div onClick={toggleProfileInfo}>
                    <FaEllipsisV />
                </div>
            </div>

            <div className="ad-body">

                <div className={profileInfo ? "profile-info" : "closed-info"}>
                    <FaTimes onClick={toggleProfileInfo} />
                    <div className="ad-button-wrapper">
                        <FaMarker />
                        <button className="ad-info-btn">Follow</button>
                    </div>
                    <div className="ad-button-wrapper">
                        <FaMinusCircle />
                        <button className="ad-info-btn">Block</button>
                    </div>
                </div>

                <div className={adInfo ? "ad-info" : "closed-info"}>
                    <FaTimes onClick={toggleAdInfo} />
                    <div className="ad-button-wrapper">
                        <FaSave />
                        <button className="ad-info-btn">Bookmark</button>
                    </div>
                    <div className="ad-button-wrapper">
                        <FaShare />
                        <button className="ad-info-btn">Share to</button>
                    </div>
                    <div className="ad-button-wrapper">
                        <FaFlag />
                        <button className="ad-info-btn">Report</button>
                    </div>
                </div>

                {ad?.shelf && (
                    <div
                        className="feed-ad-text"
                        onClick={() =>
                            navigate(
                                `/b/${ad?.shelf.storeId?.name}/${ad?.shelf?.name}`,
                                { state: { shelf: ad.shelf } }
                            )
                        }
                    >
                        <h3>{ad?.shelf?.name}</h3>
                        <p>{ad?.shelf?.description}</p>
                    </div>
                )}

                <div className="adcard-images">
                    {renderProducts()}
                </div>
            </div>

            <div className="ad-footer">
                <div className="ad-footer-icon">
                    <p    
                    onClick={() =>navigate(`/b/${ad?.shelf.storeId?.name}/${ad?.shelf?.name}`,{ state: { shelf: ad.shelf } })
                        }>See more</p>
                </div>

                <div
                    className="ad-footer-icon"
                    onClick={toggleAdInfo}
                >
                    <FaInfoCircle />
                </div>
            </div>
        </div>
    )
}

export default ShelfAd